import { lineServerApiDefinition } from "../../client/src/apiTyping.ts";

type ExampleMap = Record<
  keyof typeof lineServerApiDefinition,
  { request: Record<string, unknown>; response: Record<string, unknown> }
>;

export const endpointExamples: ExampleMap = {
  sendMessage: {
    request: {
      fromNumber: "972501234567",
      toNumber: "972509876543@c.us",
      message: "Hello! This is a test message.",
      linkPreview: false,
      token: "your-secret-token",
    },
    response: { messageId: "3EB0123456789ABCDEF" },
  },
  sendMedia: {
    request: {
      fromNumber: "972501234567",
      toNumber: "972509876543@c.us",
      base64:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==",
      type: "image",
      caption: "Check out this image!",
      token: "your-secret-token",
    },
    response: { messageId: "3EB0987654321FEDCBA" },
  },
  editMessage: {
    request: {
      fromNumber: "972501234567",
      messageId: "3EB0123456789ABCDEF",
      newText: "Updated message text",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  deleteMessage: {
    request: {
      fromNumber: "972501234567",
      chatId: "972501234567@c.us",
      messageId: "3EB0123456789ABCDEF",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  sendReaction: {
    request: {
      fromNumber: "972501234567",
      messageId: "3EB0123456789ABCDEF",
      reaction: "\u{1F44D}",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  sendTypingIndication: {
    request: {
      fromNumber: "972501234567",
      chatId: "972509876543@c.us",
      durationMs: 3000,
      token: "your-secret-token",
    },
    response: { success: true },
  },
  stopTypingIndication: {
    request: {
      fromNumber: "972501234567",
      chatId: "972509876543@c.us",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  getGroups: {
    request: {
      fromNumber: "972501234567",
      token: "your-secret-token",
    },
    response: {
      groups: [
        { id: "120363123456789012@g.us", name: "My Cool Group", isAdmin: true },
        {
          id: "120363987654321098@g.us",
          name: "Another Group",
          isAdmin: false,
        },
      ],
    },
  },
  addUserToWhatsAppGroup: {
    request: {
      fromNumber: "972501234567",
      groupId: "120363123456789012@g.us",
      userId: "972509876543@c.us",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  getCommonWhatsappGroups: {
    request: {
      fromNumber: "972501234567",
      userId: "972509876543@c.us",
      token: "your-secret-token",
    },
    response: {
      groups: [{ id: "120363123456789012@g.us", name: "Shared Group" }],
    },
  },
  getWhatsappJoinRequests: {
    request: {
      fromNumber: "972501234567",
      groupId: "120363123456789012@g.us",
      token: "your-secret-token",
    },
    response: {
      requests: [
        {
          requesterId: "972509876543@c.us",
          addedById: null,
          parentGroupId: null,
          method: "non_admin_add",
          timestamp: 1703251200000,
        },
      ],
    },
  },
  approveWhatsappJoinRequests: {
    request: {
      fromNumber: "972501234567",
      groupId: "120363123456789012@g.us",
      requesterIds: ["972509876543@c.us"],
      token: "your-secret-token",
    },
    response: {
      results: [
        {
          requesterId: "972509876543@c.us",
          error: null,
          message: "Approved successfully",
        },
      ],
    },
  },
  rejectWhatsappJoinRequests: {
    request: {
      fromNumber: "972501234567",
      groupId: "120363123456789012@g.us",
      requesterIds: ["972509876543@c.us"],
      token: "your-secret-token",
    },
    response: {
      results: [
        {
          requesterId: "972509876543@c.us",
          error: null,
          message: "Rejected successfully",
        },
      ],
    },
  },
  getGroupMembers: {
    request: {
      fromNumber: "972501234567",
      groupId: "120363123456789012@g.us",
      token: "your-secret-token",
    },
    response: {
      members: [
        { id: "972509876543@c.us", isAdmin: true, isSuperAdmin: true },
        { id: "972501111111@c.us", isAdmin: false, isSuperAdmin: false },
      ],
    },
  },
  getWhatsappGroupDetails: {
    request: {
      fromNumber: "972501234567",
      groupLink: "https://chat.whatsapp.com/AbCdEfGhIjK",
      token: "your-secret-token",
    },
    response: {
      success: true,
      id: "120363123456789012@g.us",
      subject: "My Group",
      desc: "Group description",
      size: 42,
      participants: [
        { id: "972509876543@c.us", isAdmin: true, isSuperAdmin: false },
      ],
    },
  },
  getGroupInviteLink: {
    request: {
      fromNumber: "972501234567",
      groupId: "120363123456789012@g.us",
      token: "your-secret-token",
    },
    response: {
      inviteLink: "https://chat.whatsapp.com/AbCdEfGhIjK",
    },
  },
  joinGroupByInviteLink: {
    request: {
      fromNumber: "972501234567",
      groupLink: "https://chat.whatsapp.com/AbCdEfGhIjK",
      token: "your-secret-token",
    },
    response: {
      status: "joined",
      chatId: "120363123456789012@g.us",
    },
  },
  blockContact: {
    request: {
      fromNumber: "972501234567",
      contactId: "972509876543@c.us",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  unblockContact: {
    request: {
      fromNumber: "972501234567",
      contactId: "972509876543@c.us",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  convertLidToNumber: {
    request: {
      fromNumber: "972501234567",
      lid: "119846817792023@lid",
      token: "your-secret-token",
    },
    response: { number: "972509876543@c.us" },
  },
  setWebhook: {
    request: {
      phoneNumber: "972501234567",
      url: "https://your-server.com/webhook",
      token: "your-secret-token",
    },
    response: {},
  },
  addWebhook: {
    request: {
      phoneNumber: "972501234567",
      url: "https://your-server.com/webhook",
      token: "your-secret-token",
    },
    response: {},
  },
  removeWebhook: {
    request: {
      phoneNumber: "972501234567",
      url: "https://your-server.com/webhook",
      token: "your-secret-token",
    },
    response: {},
  },
  reconnect: {
    request: {
      number: "972501234567",
      token: "your-secret-token",
    },
    response: {},
  },
  setLoginMethod: {
    request: {
      phoneNumber: "972501234567",
      preferCodeLogin: true,
      token: "your-secret-token",
    },
    response: { success: true },
  },
  clearCredentials: {
    request: {
      phoneNumber: "972501234567",
      token: "your-secret-token",
    },
    response: { success: true },
  },
  changeWhatsappAccountName: {
    request: {
      phoneNumber: "972501234567",
      name: "My Business Bot",
      token: "your-secret-token",
    },
    response: {},
  },
  changeWhatsappAccountAvatar: {
    request: {
      phoneNumber: "972501234567",
      imageBase64: "/9j/4AAQSkZJRg...",
      token: "your-secret-token",
    },
    response: {},
  },
  changeWhatsappAccountBio: {
    request: {
      phoneNumber: "972501234567",
      bio: "Powered by Supergreen",
      token: "your-secret-token",
    },
    response: {},
  },
  deleteAccount: {
    request: {
      phoneNumber: "972501234567",
      token: "your-secret-token",
    },
    response: { success: true },
  },
};
